<template>
  <div class="teacher-course-index" v-loading="loading">
    <teacher-course-update
      @selectType="selectTypeParent"
      @selectTestkit="selectTestkitParent"
      v-if="type == 'update'"
      :tabCourseUpdate="tabCourseUpdate">
    </teacher-course-update>

    <teacher-testkit-update
      @selectType="selectTypeParent"
      @selectTabCourseUpdate="selectTabCourseUpdateParent"
      v-if="type == 'testkit'"
      :courseID="courseID"
      :testkit="testkit">
    </teacher-testkit-update>
  </div>
</template>

<script>
import TeacherCourseUpdate from './TeacherCourseUpdate'
import TeacherTestkitUpdate from './TeacherTestKitUpdate'
export default {
  name: 'TeacherCourseMain',
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    TeacherCourseUpdate,
    TeacherTestkitUpdate
  },
  data () {
    return {
      loading: false,
      canSubmit: true,
      type: 'update',
      courseID: 0,
      testkit: {},
      tabCourseUpdate: 'first'
    }
  },
  mounted () {
    this.courseID = this.$route.params.course_id
  },
  methods: {
    selectTypeParent (type) {
      this.type = type
    },
    selectCourseIDParent (courseID) {
      this.courseID = courseID
    },
    selectTabCourseUpdateParent (tabCourseUpdate) {
      this.tabCourseUpdate = tabCourseUpdate
    },
    selectTestkitParent (testkit) {
      this.testkit = testkit
    }
  },
  watch: {}
}
</script>

<style type="text/css" scoped>

</style>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/courses/TeacherCourseMain.vue